<template>
  <div class="page-template">
    <div class="page-title">{{title}}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="submit">
      </form-template>
    </div>
  </div>
</template>
<script>
  import formTemplate from "@/components/template/formTemplate";
  // import api from "@/config/api";

  export default {
    components: {
      formTemplate,
    },
    data() {
      return {
        title: '',
        dialogVisibility: false,
        // 高级搜索条件
        addColumns: {
          formType: 'add',
          labelWidth: "120px",
          span: 12,
          columns: [
            {
              label: "上传头像",
              type: "textarea",
              prop: "loginName",
              rule: [
                {required: true, message: "请输入旧密码", trigger: "blur"}
              ]
            },
          ],
        }
      };
    },
    mounted() {
      this.title = document.title;
      this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
    },
    methods: {
      submit() {
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/page/system/user/Head.vue